import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

import { OrderDeliveryInfo } from '@/models';
import { Routes } from '@/router';
import { FeedbackResponse } from '@/models/feedback';
import { CountryCode } from '@/store/ui';
import { getCountryCodeByTopLevelDomain } from '@/helpers';

@Component({
  name: 'CmgBanner',
})
export default class CmgBanner extends Vue {
  lastCheckedTime: moment.Moment = moment();
  delivery: OrderDeliveryInfo | null = null;

  @Prop({ default: false, type: Boolean })
  blur!: boolean;

  get orderStatusBarVisible(): boolean {
    if (this.$route.name === Routes.Checkout || this.$route.name === Routes.OrderConfirmation) {
      return false;
    }

    if (!this.order || !this.$appStore.state.customer.jwt) {
      return false;
    }

    return !this.isExpired;
  }

  get sessionExpiredBarVisible(): boolean {
    return this.$appStore.state.ui.showSessionExpiredBanner;
  }

  get messageBannerVisible(): boolean {
    return this.$appStore.state.ui.messageBanner.visible;
  }

  get isGB(): boolean {
    return getCountryCodeByTopLevelDomain() === CountryCode.GB;
  }

  get isPageNotFound(): boolean {
    return this.$route.name === Routes.PageNotFound;
  }

  // This may have odd side affects for locations that border time zones
  get isExpired(): boolean {
    if (this.isDelivery) {
      return !!this.delivery && moment(this.delivery.quotedDeliveryTime || '').add(3, 'hour') < this.lastCheckedTime;
    }

    return !!this.order && moment(this.order.order.pickupDateTimeLocal || '').add(3, 'hour') < this.lastCheckedTime;
  }

  get isDelivery(): boolean {
    return !!this.order && !!this.order.order.delivery;
  }

  get order() {
    return this.$appStore.state.order.lastOrder.order;
  }

  get feedback(): FeedbackResponse | null {
    return this.$appStore.state.order.feedback;
  }
}
